const barColor = [
  "rgba(122, 196, 165, 1)",
  "rgba(241, 127, 76, 1)",
];

const frameworkA6Options = {
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: function(context){
          return context.dataset.label+": "+context.parsed.y+"%"
        }
      }
    },
    datalabels: {
      display: false
    },
    title: {
      display: true,
      text: "No Rubric vs Rubric: Impact Accuracy",
      font: {
        size: 15
      }
    }
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      ticks: {
        callback: function(value, index, values) {
          return value+"%";
        }
      }
    },
    x: {
      title: {
        display: true,
        text: "System"
      }
    }
  },
};

const frameworkA6Data = {
  labels: ["Aegis", "Aware", "BPrism", "Caster", "C-Core", "CPSS",
            "Emma", "Ernie", "FIQ", "Griffeye", "PHA", "SRD", "ARTCC", "CCL", "Thermal"],
  datasets: [
    {
      label: "No Rubric",
      backgroundColor: [barColor[0], barColor[0], barColor[0], barColor[0], barColor[0],
        barColor[0], barColor[0], barColor[0], barColor[0], barColor[0], barColor[0],
        barColor[0], barColor[0].replace(", 1)", ", 0.2"),
        barColor[0].replace(", 1)", ", 0.2"),
        barColor[0].replace(", 1)", ", 0.2")],
      borderColor: barColor[0],
      data: [91, 48, 74, 24, 39, 74, 62, 76, 36, 68, 42, 55, 66, 50, 21],
      borderWidth: 1,
    },
    {
      label: "Rubric",
      backgroundColor: [barColor[1], barColor[1], barColor[1], barColor[1], barColor[1],
        barColor[1], barColor[1], barColor[1], barColor[1], barColor[1], barColor[1],
        barColor[1], barColor[1].replace(", 1)", ", 0.2"),
        barColor[1].replace(", 1)", ", 0.2"),
        barColor[1].replace(", 1)", ", 0.2")],
      borderColor: barColor[1],
      data: [85, 65, 73, 27, 50, 71, 78, 85, 57, 39, 36, 68, 75, 36, 21],
      borderWidth: 1,
    }
  ],
};

export {frameworkA6Data, frameworkA6Options};